import unescapedText from 'I18n/utils/unescapedText';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { enableTaskCompletionModal } from 'user-context/onboarding';
import { commerceConvertDealToTool } from 'getting-started-shared-tasks/taskNames';
const useShareQuoteModalClose = ({
  onClose,
  embeddedShowAlert,
  isQuoteCreated
}) => {
  const showAlert = ({
    message
  }) => {
    const payload = {
      titleText: unescapedText('quotesUiLib.shareQuoteModal.alert.success'),
      message,
      type: 'success'
    };
    if (embeddedShowAlert) {
      embeddedShowAlert(payload);
    } else {
      FloatingAlertStore.addAlert(payload);
    }
  };
  const handleOnClose = () => {
    if (isQuoteCreated) {
      enableTaskCompletionModal(commerceConvertDealToTool, {
        targetWindow: window.parent
      });
      showAlert({
        message: unescapedText('quotesUiLib.shareQuoteModal.alert.created')
      });
    }
    onClose();
  };
  const handleSendEmailOnClose = () => {
    showAlert({
      message: unescapedText('quotesUiLib.shareQuoteModal.alert.emailed')
    });
    onClose();
  };
  return {
    handleOnClose,
    handleSendEmailOnClose
  };
};
export default useShareQuoteModalClose;